<!--新版标准工艺路线-->
<template>
  <ls-table-layout>
    <template #search>
      <SearchForm ref="searchFormRef" @search="onSearch" />
    </template>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiExportStandardProcess" ref="download" />
      <a-button @click="onAddBill" type="primary" :disabled="btnLoading" v-hasPermi="['bom:bomRoutingHeaderCc:add']">
        新建
      </a-button>
      <a-button @click="importExcelHandleOpen" v-hasPermi="['bom:bomRoutingHeaderCc:import']">导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['bom:bomRoutingHeaderCc:export']">导出</a-button>
<!--      <a-button @click="importTemplate" v-hasPermi="['bom:bomRoutingHeaderCc:template']">下载模板</a-button>-->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="baseTable"
          :columns="columns"
          :table-props="tableProps"
          :scroll="{ x: 800, fixScreen: true }"
          :custom-selection="{ stickyFixed: true }"
        >
          <template #operation="{ record }">
            <a-button
              v-hasPermi="['bom:bomRoutingHeaderCc:edit']"
              type="link"
              class="link-btn mr-4"
              @click="() => onEdit(record)"
            >编辑</a-button>
            <a-popconfirm
              v-hasPermi="['bom:bomRoutingHeaderCc:remove']"
              title="是否删除该条数据？"
              @confirm="() => onDelete(record)"
            >
              <a-button
                type="link"
                class="link-btn"
              >删除</a-button>
            </a-popconfirm>
          </template>
        </ls-api-table>
      </div>
      <AddModal ref="addModalRef" :mainBtnLoading="btnLoading" @successCall="refreshList" />
      <ImportModal ref="importModalRef" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, transferEnumToMap } from '@/utils/util'
import {
  apiGetStandardProcessList,
  apiExportStandardProcess,
  apiDeleteStandardProcess
} from '@/api/mes/basedata/standardProcessNew'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchForm from './components/search-form.vue'
import AddModal from './components/add-modal.vue'
import { STATUS_CODE } from './enums.js';
import ImportModal from './components/import-modal.vue'

export default {
  name: 'StandardProcessNew',
  components: {
    DownloadModal,
    SearchForm,
    AddModal,
    ImportModal
  },
  data() {
    this.statusNameMap = transferEnumToMap(STATUS_CODE)
    return {
      btnLoading: false,
      apiExportStandardProcess,
      // 导入excel
      excelVisible: false,
      tableProps: {
        requestApi: generateLsTableResData(apiGetStandardProcessList),
        pageCurrent: false
      },
      // 表格字段
      columns: [
        {
          title: '加工组织编码',
          dataIndex: 'organizationCode',
          align: 'center'
        },
        {
          title: '加工组织名称',
          dataIndex: 'organizationName',
          ellipsis: true,
          customRender: (text, record) => <router-link to={{ name: 'standardProcessNewDetail', params: { id: record.id } }} >{ text }</router-link>,
          align: 'center'
        },
        {
          title: '工艺路线编码',
          dataIndex: 'routingCode',
          align: 'center'
        },
        {
          title: '工艺路线名称',
          dataIndex: 'routingDesc',
          align: 'center'
        },
        {
          title: '版本号',
          dataIndex: 'version',
          align: 'center'
        },
        {
          title: '是否默认',
          dataIndex: 'defaultIs',
          align: 'center',
          customRender: (text) => {
            return text === 'Y' ? '是' : (text === 'N' ? '否' : '');
          }
        },
        {
          title: '生效日期',
          dataIndex: 'effectDate',
          customRender: this.formatTime,
          align: 'center'
        },
        {
          title: '失效日期',
          dataIndex: 'expireDate',
          customRender: this.formatTime,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'routingStatus',
          customRender: (text) => {
            return this.statusNameMap[text] || '';
          },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          stickyFixed: 'right',
          width: 90
        }
      ]
    }
  },
  mounted() {
    this.refreshList();
    this.$EventBus.$on('RefreshStandardProcessNewListEventName', this.refreshList);
  },
  beforeDestroy() {
    this.$EventBus.$off('RefreshStandardProcessNewListEventName', this.refreshList);
  },
  methods: {
    onEdit(record) {
      this.$router.push({
        name: 'standardProcessNewEdit',
        params: { id: record.id }
      })
    },
    onDelete(record) {
      this.$set(record, 'loading', true);
      apiDeleteStandardProcess(record.id).then(res => {
        if(res.code === 200) {
          this.$message.success('删除成功');
          this.refreshList();
        }
      }).finally(() => {
        this.$set(record, 'loading', false);
      })
    },
    // 新建
    onAddBill() {
      this.$refs.addModalRef.show()
    },
    refreshList(currentPageIs) {
      this.currentPageIs = !!currentPageIs
      this.$refs.searchFormRef.handleFormSearch()
    },
    getLookupList(type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams)
        .then()
        .then((response) => {
          this[arr] = response.rows
        })
    },
    onSearch(params) {
      this.$refs.baseTable.searchParams = params
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    /** 导入excel */
    importExcelHandleChange(info) {
      const status = info.file.status
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel(e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.refreshList()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen() {
      this.$refs.importModalRef.show({
        url: '/bom/bomRoutingHeaderCc/import',
        templateUrl: 'bom/bomRoutingHeaderCc/template',
        templateName: '标准工艺路线导入模板'
      })
    },
    /** 下载模板操作 */
    importTemplate() {
      this.download('bom/bomRoutingHeaderCc/template', {}, `标准工艺路线导入模板_${new Date().getTime()}.xlsx`)
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = this.$refs.baseTable.searchParams;
      this.$refs.download.openModal(params)
    },
    formatTime(time) {
      let result = '';
      if(time) {
        result = this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
      }
      return result;
    }
  }
}
</script>

<style scoped lang="less">
.link-btn {
  padding: 0;
  height: unset;
}
.mr-4 {
  margin-right: 4px;
}
</style>
